import Translatable from '../translatable_text/Translatable';

function DallService() {

  return (
    <section className="skills-img-crev pb-100 pt-50">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap justify-between d-rotate wow">
          <div className="w-full lg:w-4/12 lg:ml-[8.333333%] flex items-center">
            <div className="img md-mb80">
              <div className="hidden md:inline rotate-butn-vid">
                <a
                  href="https://dall-in.com/"
                  target="_blank"
                  rel="noreferrer"
                  className="vidx flex items-center gap-2"
                >
                  <div className="icon">
                    <i className="fas fa-globe main-color"></i>
                  </div>
                  <span className="sub-title ml-15">
                    <Translatable>Visit website</Translatable>
                  </span>
                </a>
              </div>
              <a
                href="https://dall-in.com/"
                target="_blank"
                rel="noreferrer"
                className="vidx flex items-center gap-2"
              >
              <img 
                src="/light/assets/imgs/logo/gcad.webp"
                alt="img"
                className="radius-30"
                width="100%" height="100%" loading='lazy'
                />
              </a>
            </div>
          </div>
          <div className="w-full lg:w-6/12 flex items-center rotate-text">
            <div className="content full-width">
              <div className="sec-head mb-50">
                <h2 className="sub-title mb-15 main-color">
                  <Translatable>Main Product</Translatable>
                </h2>
                <h2 className="d-slideup  d-rotate wow">
                  <span className="up-text rotate-text text-4xl">
                    <Translatable>Dall In Platform</Translatable>
                  </span>
                </h2>
              </div>
              <div className="flex justify-end">
                <div className="w-full lg:w-11/12">
                  <div className="text">
                    <h2 style={{ fontSize: '18px', lineHeight: '1.8', fontWeight: '200' }} className='opacity-6'>
                      <Translatable>
                        A platform that includes services for individuals and companies in the field of artificial intelligence in linking individuals and companies for employment or training, measuring productivity and building a virtual city for employment
                      </Translatable>
                    </h2>
                  </div>
                    <div className="ltr:hidden rtl:flex flex-wrap mt-50 pt-50 bord-thin-top ">
                      <div className="w-full sm:w-6/12 centered-element-resp">
                        <div className="item flex items-center sm-mb30 gap-4">
                          <h2 className="fz-60 line-height-1">
                            <span className="numb-count">6k</span>
                            <span className="fz-30">+</span>
                          </h2>
                          <span className="sub-title opacity-7">
                            اختبار <br />
                            تجارب
                          </span>
                        </div>
                      </div>
                      <div className="w-full sm:w-6/12 centered-element-resp">
                        <div className="item flex items-center gap-4">
                          <h2 className="fz-60 line-height-1">
                            <span className="numb-count">86</span>
                            <span className="fz-30">%</span>
                          </h2>
                          <span className="sub-title opacity-7">
                            مستوى <br />
                            الدقة
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="rtl:hidden ltr:flex flex-wrap mt-50 pt-50 bord-thin-top">
                      <div className="w-full sm:w-6/12 centered-element-resp">
                        <div className="item flex items-center sm-mb30 gap-4">
                          <h2 className="fz-60 line-height-1">
                            <span className="numb-count">6k</span>
                            <span className="fz-30">+</span>
                          </h2>
                          <span className="sub-title opacity-7">
                            Test <br />
                            Experments
                          </span>
                        </div>
                      </div>
                      <div className="w-full sm:w-6/12 centered-element-resp">
                        <div className="item flex items-center gap-4">
                          <h2 className="fz-60 line-height-1">
                            <span className="numb-count">86</span>
                            <span className="fz-30">%</span>
                          </h2>
                          <span className="sub-title opacity-7">
                            Accuracy <br />
                            Level
                          </span>
                        </div>
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default DallService;
